export const PRIVATE_PATHS = ['/admin', '/billing', '/browse'];

// Set by the middleware when a signed-out visitor opens a private page, so sign-in can return there.
export const POST_LOGIN_REDIRECT_COOKIE = 'post_login_redirect';

// Set when an Auth0 user with no Admin Portal role is signed out, so sign-in can say why. It
// outlives the round trip through Auth0's logout, which can only return to an allowed URL.
export const NO_ADMIN_PORTAL_ACCESS_COOKIE = 'no_admin_portal_access';
